import { t } from "@lingui/macro";
import type { OiProformaWhereColumn } from "@src/__generated__/urql-graphql";
import { FiltersPanel } from "@src/utils/components/filters/components/filters-panel";
import { observer } from "mobx-react-lite";
import { useStore } from "../../store";

export const FilterPanel = observer(function FilterPanel() {
  const store = useStore();
  return (
    <div className={"p-6"}>
      <FiltersPanel<OiProformaWhereColumn>
        filters={store.where}
        searchPlaceholder={t`Search by proforma invoice no, brand, project`}
        onSearch={(val) => {
          store.setSearchTerm(val);
          store.pagination.resetPage();
        }}
      />
    </div>
  );
});
